<template>
  <div>
    <el-navbar />
    <main class="mt-5">
      <div id="carouselExampleSlidesOnly" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="../../public/storage/contact-us2.jpg" class="d-block w-100" alt="Photo by Negative Space: https://www.pexels.com/photo/marketing-office-working-business-33999/">
            <div class="carousel-caption text-body d-md-block" style="top:30%">
              <h2 class="display-4 fw-normal">Mobile Tech Zone Support kontaktieren</h2>
              <a href="#contact-data" title="Scroll down" class="btn btn-link text-primary mt-3">
                <i class="fa-solid fa-angles-down fa-3x"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="w-100" id="contact-data">
        <div class="row row-cols-2">
          <div class="col-12 col-lg-6 px-0 badge bg-dark d-flex justify-content-center align-items-center">
            <div class="container my-3 my-lg-1 ms-lg-4 text-start">
              <h3 class="mb-md-4 display-6">Unsere Kontaktdaten:</h3>
              <p class="mb-2">
                <i class="fa-solid fa-envelope text-primary fa-2x"></i>
                <a title="Send Email" class="fw-light d-inline-block ms-1 nav-link text-white h6" href="mailto:info@mobiletechzone.at">info@mobiletechzone.at</a>
              </p>
              <p class="mb-2">
                <i class="fa-solid fa-square-phone-flip text-primary fa-2x"></i>
                <a title="Call us" class="fw-light d-inline-block ms-1 nav-link text-white h6" href="tel:+4369981170084">+43 699 81170084</a>
              </p>
              <p class="mb-2">
                <i class="fa-solid fa-location-dot text-primary fa-2x"></i>
                <a title="Adresse" class="fw-light d-inline-block ms-1 nav-link text-white h6" href="https://goo.gl/maps/CXKDeZvPnneC33hR8">Landstraße Hauptstraße 92-94 1/2 1030, Wien</a>
              </p>
            </div>
          </div>
          <div class="col-12 col-lg-6 px-0 " id="googleMaps">
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10637.505677586432!2d16.393871!3d48.1993651!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf0656c1c1bfe6c31!2sMobile%20Tech%20Zone%20-%20Handyshop%20Wien%20%7C%20Express%20Handy%20Reparatur%20%7C%20Display%20%26%20Akku-Tausch%20%7C%20Zubeh%C3%B6r!5e0!3m2!1sen!2sat!4v1662323136263!5m2!1sen!2sat" width="100%" height="650" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>
      </div>
    </main>
    <el-footer />
  </div>
</template>

<script>
import elNavbar from "../components/Navbar.vue";
import elFooter from "../components/Footer.vue";

export default {
  name: "Contact",

  metaInfo() {
    return {
      title: "Contact",
      titleTemplate: "%s | Mobile Tech Zone",
    };
  },

  components: { elNavbar, elFooter },

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.state.utils.loaded = true;
    });
  },

  methods: {},
};
</script>

<style scoped></style>
